import { render } from "./DataSetInfo.vue?vue&type=template&id=85171eac"
import script from "./DataSetInfo.vue?vue&type=script&lang=js"
export * from "./DataSetInfo.vue?vue&type=script&lang=js"

import "./DataSetInfo.vue?vue&type=style&index=0&id=85171eac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__